import { render, staticRenderFns } from "./ServicoView.vue?vue&type=template&id=4b8fc490"
import script from "./ServicoView.vue?vue&type=script&lang=js"
export * from "./ServicoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports